import {Component, HostBinding, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'sc-labeled-input',
    templateUrl: './sc-labeled-input.component.html',
    styleUrls: ['./sc-labeled-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SCLabeledInputComponent),
        multi: true
    }]
})
export class SCLabeledInputComponent implements ControlValueAccessor {

    @Input()
    public label: string;
    @Input()
    public placeholder: string;


    public inputValid = false;

    public value = '';
    public propagateChange: (_: any) => void = (_: any) => {};

    public onTouched: () => void = () => {};

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }




    public writeValue(value: string): void {
      this.inputValid = true;
        this.value = value;
    }


    public updateChanges(): void {

      this.inputValid = false;
      if(this.isValidZip(this.value))
      {
        this.inputValid = true;
        this.propagateChange(this.value);
        this.onTouched();
      }


    }


    public  isValidZip(sZip: any) {
      return /^[0-9]*$/.test(sZip);
   }

    public clear(): void {
        this.value = '';
        this.updateChanges();
    }

    onBlur() {
        this.onTouched();
    }
}
